import React, {useState} from 'react';
import {ReactSortable} from "react-sortablejs";
import {
    MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY
} from "@containers/singleVoyage/mutateVoyage/points/pointsList/fullMode/constants";
import {sx} from './sx'
import ReorderPointItemMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointsReorders/ReorderPointItemMutateSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import ButtonCustom from '@ui/buttons/buttonCustom/ButtonCustom';
import {useTranslation} from "react-i18next";
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";

import ActionUiHandler from "@ui/template/actionUiHandler/ActionUiHandler";
import DividerCustom from "@ui/dividerCustom/DividerCustom";
import {
    useRebuildPointsAndPositionsMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/useRebuildPointsAndPositionsMutateSingleVoyage";

interface IProps {
    closeModalFn?: () => void
}

const PointsReordersMutateSingleVoyage = ({closeModalFn}: IProps) => {

    const {
        points,
    } = useRootContextMutateSingleVoyage()

    const {
        onRebuild,
        isPending
    } = useRebuildPointsAndPositionsMutateSingleVoyage()

    const [currentPoints, setCurrentPoints] = useState<IWayPointCreationWithCorrectionsSingleVoyage[]>(points)

    const {t} = useTranslation();


    const list = currentPoints?.length >= 1 && currentPoints.map((point, index) => {
        return (
            <ReorderPointItemMutateSingleVoyage
                point={point}
                key={point.id}
                index={index}
            />
        )
    })

    const onSave = async () => {
        await onRebuild({
            points: currentPoints
        })

    }
    return (
        <ActionUiHandler
            isLoading={isPending}
            sx={sx.root}
        >
            <ReactSortable
                animation={200}
                list={currentPoints}
                setList={setCurrentPoints}
                handle={`.${MUTATE_SINGLE_VOYAGE_POINT_SORTABLE_KEY}`}
                className={'pointsReorderMutateSingleVoyage'}
                forceFallback
                scroll
                scrollSensitivity={100}
                scrollSpeed={10}
            >
                {list}
            </ReactSortable>

            <DividerCustom
                sx={sx.divider}
            />

            <ButtonCustom
                variant="contained"
                onClick={onSave}
                disabled={isPending}
            >
                {t('base.save')}
            </ButtonCustom>
        </ActionUiHandler>
    );
};

export default PointsReordersMutateSingleVoyage;